<div class="container mx-auto container-base">
    <form #form="ngForm" (keydown.enter)="$event.preventDefault()" class="form container-fluid pl-0 pr-0">
        <div class="hero-text" style="margin-left: 10px;">
            <h1 style="font-weight: 800;">{{'CONTAINER'|translate}}
                {{operation=="create"?('CREATE'|translate):('UPDATE'|translate)}}</h1>
        </div>
        <div class="location">
            <div class="content-header">
                <div class="h2 secondary-text">
                    <mat-icon>room</mat-icon> {{'LOCATION'|translate}}
                </div>
                <hr>
            </div>
            <div class="location-content" fxLayout="row wrap" fxFlexAlign="space-between">
                <mat-form-field fxFlex="100" fxFlex.gt-sm="50" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'NEIGHBOURHOOD'|translate}}</mat-label>
                    <input matInput placeholder="{{'NEIGHBOURHOOD'|translate}}" name="neighbor"
                        [(ngModel)]="model.neighbor" required>
                </mat-form-field>
                <mat-form-field fxFlex="100" fxFlex.gt-sm="50" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'STREET'|translate}}/{{'DISTRICT'|translate}}</mat-label>
                    <input matInput placeholder="{{'STREET'|translate}}/{{'DISTRICT'|translate}}" name="street"
                        [(ngModel)]="model.street" required>
                </mat-form-field>
                <mat-form-field fxFlex="50" fxFlex.gt-sm="25" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'LATITUDE'|translate}}</mat-label>
                    <input matInput placeholder="{{'LATITUDE'|translate}}" name="latitude" [(ngModel)]="model.latitude"
                        required>
                </mat-form-field>

                <mat-form-field fxFlex="50" fxFlex.gt-sm="25" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'LONGITUDE'|translate}}</mat-label>
                    <input matInput placeholder="{{'LONGITUDE'|translate}}" name="longitude"
                        [(ngModel)]="model.longitude" required>
                </mat-form-field>
                <div class="location-selected-btn" fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="start center">
                    <button mat-raised-button type="reset" (click)="containerLocation()">
                        <span>{{'ADD_LOCATION_ON_MAP'|translate}}</span>
                    </button>
                </div>

                <mat-form-field fxFlex="100" fxFlex.gt-sm="50" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'STREET'|translate}}/{{'DISTRICT'|translate}}{{'LOCATION'|translate}}</mat-label>
                    <input matInput
                        placeholder="{{'STREET'|translate}}/{{'DISTRICT'|translate}}{{'LOCATION'|translate}}"
                        name="streetDesc" [(ngModel)]="model.streetDesc" required>
                </mat-form-field>

                <mat-form-field fxFlex="100" fxFlex.gt-sm="50" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'TYPE'|translate}}</mat-label>
                    <mat-select [(ngModel)]="model.rootType" name="type" required>
                        <mat-option [value]="containerEnum.Container">{{'CONTAINER'|translate}}</mat-option>
                        <mat-option [value]="containerEnum.Glass">{{'GLASS'|translate}}</mat-option>
                        <mat-option [value]="containerEnum.Metal">{{'METAL'|translate}}</mat-option>
                        <mat-option [value]="containerEnum.Paper">{{'PAPER'|translate}}</mat-option>
                        <mat-option [value]="containerEnum.Plastic">{{'PLASTIC'|translate}}</mat-option>
                        <mat-option [value]="containerEnum.Underground">{{'UNDERGROUND'|translate}}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'AFFILIATED_REGION'|translate}}</mat-label>
                    <mat-select [(ngModel)]="selectedPoligon" placeholder="{{'AFFILIATED_REGION'|translate}}"
                        name="poligons">
                        <mat-option *ngFor="let item of poligonList" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field *ngIf="companyId==1" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'COMPANY'|translate}}</mat-label>
                    <mat-select [(ngModel)]="selectedCompany" (selectionChange)="onCompanyChange(selectedCompany)" placeholder="{{'COMPANY'|translate}}" required
                        name="companies">
                        <mat-option *ngFor="let item of companyList" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="container">
            <div class="content-header">
                <div class="h2 secondary-text">
                    <mat-icon>delete</mat-icon> {{'CONTAINER'|translate}}
                </div>
                <hr>
            </div>
            <div class="container-content" fxLayout="row wrap" fxFlexAlign="space-between">
                <mat-form-field fxFlex="100" fxFlex.gt-sm="50" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'NAME'|translate}}</mat-label>
                    <input matInput placeholder="{{'NAME'|translate}}" type="text" name="name"
                        [(ngModel)]="model.name" required>
                </mat-form-field>

                <mat-form-field fxFlex="100" fxFlex.gt-sm="50" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'ALTITUDE'|translate}} (mm)</mat-label>
                    <input matInput placeholder="{{'ALTITUDE'|translate}}" type="number" name="altitude"
                        [(ngModel)]="model.altitude" required>
                </mat-form-field>

                <mat-form-field fxFlex="100" fxFlex.gt-sm="50" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'DEAD_ZONE'|translate}} (mm)</mat-label>
                    <input matInput placeholder="{{'DEAD_ZONE'|translate}}" type="number" name="deadZone"
                        [(ngModel)]="model.deadZone" required>
                </mat-form-field>
                
                <mat-form-field fxFlex="100" fxFlex.gt-sm="50" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'COLLECTION_TIME'|translate}} (sn)</mat-label>
                    <input matInput placeholder="{{'COLLECTION_TIME'|translate}}" type="number" name="collectionTime"
                        [(ngModel)]="model.collectionTime" required>
                </mat-form-field>

                <mat-form-field fxFlex="100" fxFlex.gt-sm="50" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'CAPACITY'|translate}} (Litre)</mat-label>
                    <input matInput placeholder="{{'CAPACITY'|translate}}" type="number" name="svalue"
                        [(ngModel)]="model.sValue" required>
                </mat-form-field>

                <mat-form-field fxFlex="100" fxFlex.gt-sm="50" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'VOLUME'|translate}} (m<sup>3</sup>)</mat-label>
                    <input matInput placeholder="{{'VOLUME'|translate}}" type="number" name="hacim"
                        [(ngModel)]="model.bValue" required>
                </mat-form-field>
            </div>
        </div>
        <button mat-raised-button (click)="save()">
            <span>{{'CREATE'|translate}}</span>
        </button>
    </form>
</div>